<div class="d-flex flex-column sp-center al-center w-100 h-100 content-loader">
  <div class="loader"></div>
</div>